import { SVGProps } from "react";

export default function BulletListIcon(props: SVGProps<SVGSVGElement>) {
  const {
    height = 13,
    width = 12,
    fill = "#545454",
    stroke = "#545454",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M1.75 4H0.75C0.3365 4 0 3.6635 0 3.25V2.25C0 1.8365 0.3365 1.5 0.75 1.5H1.75C2.1635 1.5 2.5 1.8365 2.5 2.25V3.25C2.5 3.6635 2.1635 4 1.75 4ZM0.75 2C0.6125 2 0.5 2.1125 0.5 2.25V3.25C0.5 3.3875 0.6125 3.5 0.75 3.5H1.75C1.8875 3.5 2 3.3875 2 3.25V2.25C2 2.1125 1.8875 2 1.75 2H0.75Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.2"
        />
        <path
          d="M1.75 8H0.75C0.3365 8 0 7.6635 0 7.25V6.25C0 5.8365 0.3365 5.5 0.75 5.5H1.75C2.1635 5.5 2.5 5.8365 2.5 6.25V7.25C2.5 7.6635 2.1635 8 1.75 8ZM0.75 6C0.6125 6 0.5 6.1125 0.5 6.25V7.25C0.5 7.3875 0.6125 7.5 0.75 7.5H1.75C1.8875 7.5 2 7.3875 2 7.25V6.25C2 6.1125 1.8875 6 1.75 6H0.75Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.2"
        />
        <path
          d="M1.75 12H0.75C0.3365 12 0 11.6635 0 11.25V10.25C0 9.8365 0.3365 9.5 0.75 9.5H1.75C2.1635 9.5 2.5 9.8365 2.5 10.25V11.25C2.5 11.6635 2.1635 12 1.75 12ZM0.75 10C0.6125 10 0.5 10.1125 0.5 10.25V11.25C0.5 11.3875 0.6125 11.5 0.75 11.5H1.75C1.8875 11.5 2 11.3875 2 11.25V10.25C2 10.1125 1.8875 10 1.75 10H0.75Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.2"
        />
        <path
          d="M11.75 3H3.75C3.612 3 3.5 2.888 3.5 2.75C3.5 2.612 3.612 2.5 3.75 2.5H11.75C11.888 2.5 12 2.612 12 2.75C12 2.888 11.888 3 11.75 3Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.4"
        />
        <path
          d="M11.75 7H3.75C3.612 7 3.5 6.888 3.5 6.75C3.5 6.612 3.612 6.5 3.75 6.5H11.75C11.888 6.5 12 6.612 12 6.75C12 6.888 11.888 7 11.75 7Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.4"
        />
        <path
          d="M11.75 11H3.75C3.612 11 3.5 10.888 3.5 10.75C3.5 10.612 3.612 10.5 3.75 10.5H11.75C11.888 10.5 12 10.612 12 10.75C12 10.888 11.888 11 11.75 11Z"
          fill={fill}
          stroke={stroke}
          strokeWidth="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
